import { businessNode, canonical } from "./seo";
import { faqSchema } from "./service-schema";
import { getLocation } from "./locations";
import { ogImageMeta } from "./og-image";
import { applySeoOverrides, type PageSeoOverride } from "./seo-overrides";

export function localBusinessSchema(slug: string) {
  const loc = getLocation(slug);
  return businessNode({
    url: loc.path,
    areaServed: { "@type": loc.areaType, name: loc.displayName },
    aggregateRating: { ratingValue: "4.8", reviewCount: "84" },
  });
}


export function locationHead(slug: string, override?: PageSeoOverride | null) {
  const loc = getLocation(slug);
  const url = canonical(loc.path);
  return applySeoOverrides({
    meta: [
      { title: loc.metaTitle },
      { name: "description", content: loc.metaDescription },
      { property: "og:title", content: loc.metaTitle },
      { property: "og:description", content: loc.metaDescription },
      { property: "og:url", content: url },
      { property: "og:type", content: "website" },
      { name: "twitter:title", content: loc.metaTitle },
      { name: "twitter:description", content: loc.metaDescription },
      ...ogImageMeta("home"),
    ],
    links: [{ rel: "canonical", href: url }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(localBusinessSchema(slug)),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify(faqSchema(loc.faqs)),
      },
    ],
  }, override);
}
